import dayjs from 'dayjs'

export function useFormatDate(date?: string): string {
  if (!date) {
    return ''
  }
  // Конвертируем строку в число, если это timestamp в миллисекундах
  // Проверяем, является ли строка числом (timestamp)
  const dateValue = /^\d+$/.test(String(date)) ? Number(date) : date
  const dateObj = dayjs(dateValue)
  
  const time = dateObj.format('HH:mm')
  const isTomorrow = dayjs().add(1, 'day').format('DD.MM.YYYY') === dateObj.format('DD.MM.YYYY')
  if (isTomorrow) {
    return `завтра, ${time}`
  }
  const isToday = dayjs().format('DD.MM.YYYY') === dateObj.format('DD.MM.YYYY')
  if (isToday) {
    return `сегодня, ${time}`
  }
  const isYesterday =
    dayjs().subtract(1, 'day').format('DD.MM.YYYY') === dateObj.format('DD.MM.YYYY')
  if (isYesterday) {
    return `вчера, ${time}`
  }
  return dateObj.format('D MMMM, HH:mm')
}
